<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <main class="marginTop relative">
        <span
          @click="redirectCrm"
          class="cursor-pointer absolute top-1 left-1 z-20 flex uppercase font-bold bg-gray-100 px-3 rounded-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-red-500 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
          CRM
        </span>

        <div
          class="max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3 "
        >
          <div class="lg:col-start-3 lg:col-span-1">
            <div class="p-4 bg-gray-900 shadow sm:rounded-lg">
              <div class="text-center">
                <h2
                  class="text-base font-semibold text-indigo-600 tracking-wide uppercase"
                >
                  Create
                </h2>
                <p
                  class="-mt-1 text-sm font-extrabold text-gray-50 sm:text-2xl sm:tracking-tight"
                >
                  Email Template
                </p>
                <p class="mt-4 mx-auto text-sm text-gray-300">
                  Start building for free, then add a site plan to go live.
                  Account plans unlock additional features.
                </p>
              </div>
            </div>

            <div
              class="mt-2 px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6"
            >
              <dt class="text-sm font-medium text-gray-500 truncate">
                Total Contacts
              </dt>
              <dd class="mt-1 text-3xl font-semibold text-gray-900">
                {{ contacts.length }}
              </dd>
            </div>
          </div>

          <section class="space-y-6 lg:col-start-1 lg:col-span-2">
            <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
              <div class="text-center mb-4">
                <input
                  v-model="search"
                  type="search"
                  name="serch"
                  placeholder="Search Contact"
                  class="shadow bg-white h-10 w-3/4 px-5 pr-10 rounded-full text-sm focus:outline-none"
                />

                <div class="btn-group">
                  <button
                    type="button"
                    class="ml-2 btn bg-blue-100 text-blue-700 hover:bg-blue-200 text-sm rounded-full shadow-md dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Filter by Tag
                  </button>
                  <div class="dropdown-menu">
                    <a
                      @click="searchByFilter(tag)"
                      class="dropdown-item mt-1"
                      v-for="tag in tags"
                      :key="tag.id"
                      >{{ tag.name }}</a
                    >
                  </div>
                </div>
              </div>

              <div class="flex flex-col">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div
                    class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                  >
                    <div
                      class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                    >
                      <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Name
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Phone
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Tags Assigned
                            </th>
                            <th scope="col" class="relative px-6 py-3">
                              <span class="sr-only">view</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr
                            v-for="user in userFilter.slice(0, numberFilter)"
                            :key="user.id"
                          >
                            <td class="px-6 py-4 whitespace-nowrap">
                              <div class="flex items-center">
                                <div class="flex-shrink-0 h-10 w-10">
                                  <img
                                    class="h-10 w-10 rounded-full"
                                    :src="url + user.name + rest"
                                    alt=""
                                  />
                                </div>
                                <div class="ml-4">
                                  <div
                                    class="text-sm font-medium text-gray-900"
                                  >
                                    {{ user.name }}
                                  </div>
                                  <div class="text-sm text-gray-500">
                                    {{ user.email }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap">
                              <div class="text-sm text-gray-900">
                                {{ user.phone }}
                              </div>
                              <!-- <div class="text-sm text-gray-500">Optimization</div> -->
                            </td>
                            <td class="px-6 py-4 overflow-auto h-4 ">
                              <span
                                v-for="singleTag in user.tags"
                                :key="singleTag.name"
                                class="px-2 inline-flex text-xs leading-5 m-1 font-semibold rounded-full bg-green-100 text-green-800 "
                              >
                                {{ singleTag.name }}
                              </span>
                            </td>

                            <td
                              class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                            >
                              <a
                                @click="checkUser(user)"
                                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                                >View</a
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="relative m-3">
                        <div
                          class="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <button
                            @click="numberFilter += 10"
                            type="button"
                            class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            <!-- Heroicon name: solid/plus-sm -->
                            <svg
                              class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                clip-rule="evenodd"
                              />
                            </svg>
                            <span>Show More</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Modal -->
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div v-if="checkProfile">
            <profilemodal
              :userProfile="userProfile"
              :tags="tags"
              v-on:refresh="updateUser"
            >
            </profilemodal>
          </div>
          <!-- close Modal -->
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import Profilemodal from "../Modals/ProfileModal";
export default {
  components: { Profilemodal },
  name: "crm-contacts",
  data() {
    return {
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=5564eb&color=fff",
      search: "",
      numberFilter: 8,
      checkProfile: false,
      userProfile: "",
      contacts: "",
      tags: ""
    };
  },

  created() {
    this.getContacts();
    this.getTags();
  },

  computed: {
    userFilter() {
      if (this.search == "") {
        return this.contacts;
      } else {
        return this.contacts.filter(user => {
          return (
            user.name.toLowerCase().includes(this.search.toLowerCase()) ||
            user.email.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }
    }
  },

  methods: {
    redirectCrm() {
      this.$router.push({ name: "CRM" });
    },

    searchByFilter(tag) {
      this.contacts = tag.users;
      console.log(tag);
    },

    checkUser(user) {
      this.checkProfile = true;
      this.userProfile = user;
    },

    closeCheckUser() {
      this.checkProfile = false;
      this.userProfile = "";
    },

    updateUser() {
      this.checkProfile = false;
      this.getContacts();
    },

    getContacts() {
      window.axios.get("/api/crm").then(response => {
        this.contacts = response.data;
      });
    },

    getTags() {
      window.axios.get("/api/crmTags").then(response => {
        this.tags = response.data;
      });
    }
  }
};
</script>
